/**
 * Custom Airplane Cursor with GSAP Animation
 */

export function initAirplaneCursor() {
    if (!window.gsap) {
        console.warn('GSAP not loaded, airplane cursor disabled');
        return;
    }

    // Criar elemento do cursor
    const cursor = document.createElement('div');
    cursor.className = 'cursor-airplane';
    cursor.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
            <path class="cursor-plane" fill="currentColor" d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
        </svg>
    `;
    document.body.appendChild(cursor);

    // Variáveis de posição
    let mouseX = 0;
    let mouseY = 0;
    let cursorX = 0;
    let cursorY = 0;
    let isHovering = false;
    let isActive = false;

    // Configurações de animação
    const speed = 0.15;

    // Atualizar posição do mouse
    document.addEventListener('mousemove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
    });

    // Detectar hover em elementos clicáveis
    const interactiveElements = 'a, button, [role="button"], input[type="submit"], input[type="button"], .cursor-hover';
    
    document.addEventListener('mouseover', (e) => {
        if (e.target.closest(interactiveElements)) {
            isHovering = true;
            gsap.to(cursor, {
                scale: 1.3,
                duration: 0.3,
                ease: 'power2.out'
            });
        }
    });

    document.addEventListener('mouseout', (e) => {
        if (e.target.closest(interactiveElements)) {
            isHovering = false;
            if (!isActive) {
                gsap.to(cursor, {
                    scale: 1,
                    duration: 0.3,
                    ease: 'power2.out'
                });
            }
        }
    });

    // Detectar clique
    document.addEventListener('mousedown', () => {
        isActive = true;
        gsap.to(cursor, {
            scale: 0.85,
            duration: 0.15,
            ease: 'power2.out'
        });
    });

    document.addEventListener('mouseup', () => {
        isActive = false;
        gsap.to(cursor, {
            scale: isHovering ? 1.3 : 1,
            duration: 0.3,
            ease: 'power2.out'
        });
    });

    // Animar cursor com GSAP ticker
    gsap.ticker.add(() => {
        // Smooth follow
        cursorX += (mouseX - cursorX) * speed;
        cursorY += (mouseY - cursorY) * speed;

        // Aplicar transformação
        gsap.set(cursor, {
            x: cursorX,
            y: cursorY,
        });
    });

    // Ocultar cursor em saída da janela
    document.addEventListener('mouseleave', () => {
        gsap.to(cursor, {
            opacity: 0,
            duration: 0.2
        });
    });

    document.addEventListener('mouseenter', () => {
        gsap.to(cursor, {
            opacity: 1,
            duration: 0.2
        });
    });

    // Inicializar posição
    gsap.set(cursor, {
        xPercent: -50,
        yPercent: -50,
        opacity: 0
    });

    console.log('✈️ Airplane cursor initialized');
}
